// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n-ViewSidebar--very-narrow {
  width: 170px;
}
.n-ViewSidebar--narrow {
  width: 250px;
}
.n-ViewSidebar--wide {
  width: 400px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/components/view-sidebar/ViewSidebar.less"],"names":[],"mappings":"AACE;EACE,YAAA;AAAJ;AAGE;EACE,YAAA;AADJ;AAIE;EACE,YAAA;AAFJ","sourcesContent":[".n-ViewSidebar {\n  &--very-narrow {\n    width: 170px;\n  }\n\n  &--narrow {\n    width: 250px;\n  }\n\n  &--wide {\n    width: 400px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
